export default __webpack_public_path__ + "static/media/express.e3d4f9e5.png";